import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useApp } from '../contexts/AppContext';
import { ChevronDown } from 'lucide-react';
import { NAV_GROUPS } from '../navConfig';

export default function SidebarNav({ collapsed, testPrefix = 'nav' }) {
  const { lang, role } = useApp();
  const navigate = useNavigate();
  const location = useLocation();
  const activeGroup = NAV_GROUPS.find(g => g.items.some(i => i.path === location.pathname))?.id;
  const [open, setOpen] = useState(() => ({ core: true, [activeGroup || 'p1']: true }));

  return (
    <nav style={{ padding: 'var(--space-2) 0', flex: 1 }} data-testid={`${testPrefix}-sidebar-nav`}>
      {NAV_GROUPS.map(g => {
        const items = g.items.filter(i => i.roles.includes(role));
        if (!items.length) return null;
        const isOpen = collapsed || open[g.id] || g.id === activeGroup;
        return (
          <div key={g.id} style={{ marginBottom: 2 }}>
            {!collapsed && g.id !== 'core' && (
              <button data-testid={`${testPrefix}-group-${g.id}`} onClick={() => setOpen(o => ({ ...o, [g.id]: !isOpen }))}
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', padding: '12px 20px 6px', border: 'none', background: 'transparent', cursor: 'pointer', color: 'var(--color-label-tertiary)' }}>
                <span style={{ fontSize: 10.5, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', textAlign: 'left' }}>
                  {g.pillar && <span style={{ color: 'var(--color-red)', marginRight: 6 }}>{g.pillar}</span>}{lang === 'bn' ? g.bn : g.en}
                </span>
                <ChevronDown size={12} style={{ transform: isOpen ? 'rotate(180deg)' : 'none', transition: 'transform .2s' }} />
              </button>
            )}
            {collapsed && g.id !== 'core' && <div style={{ height: 1, background: 'var(--color-separator)', margin: '6px 12px' }} />}
            {isOpen && items.map(item => {
              const isActive = location.pathname === item.path; const Icon = item.icon;
              return (
                <button key={item.path} data-testid={`${testPrefix}-${item.path.replace('/', '') || 'home'}`} onClick={() => navigate(item.path)}
                  className={`sidebar-item ${isActive ? 'sidebar-item-active' : ''} ${collapsed ? 'justify-center !px-0 !mx-0' : ''}`}
                  style={{ width: '100%', border: 'none', background: isActive ? 'var(--color-accent-light)' : 'transparent', minHeight: collapsed ? 46 : 48 }} title={collapsed ? item.en : undefined}>
                  <Icon size={19} />
                  {!collapsed && (
                    <span className="sidebar-bilingual">
                      <span className="sidebar-bilingual-primary" style={{ fontWeight: isActive ? 600 : 400, fontSize: 14 }}>{lang === 'bn' ? item.bn : item.en}</span>
                      <span className="sidebar-bilingual-secondary">{lang === 'bn' ? item.en : item.bn}</span>
                    </span>
                  )}
                </button>
              );
            })}
          </div>
        );
      })}
    </nav>
  );
}
